import {Dialog} from '@base-ui/react/dialog';

import CloseButton from '@/components/Buttons/CloseButton';
import {twx} from '@/utils/tailwindUtils';

type DialogCloseButtonProps = {
    className?: string;
};

const DialogCloseButton = ({className}: DialogCloseButtonProps) => (
    <Dialog.Close render={<CloseButton />} className={twx('absolute top-app-4 right-4 z-10', className)} />
);

export default DialogCloseButton;
